import React from 'react';
import { Icon } from 'components/ui';
import { ChipWithIcons } from '../../components';
import { useTheme, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
const ClipboardListButtonCell = (props) => {

  const theme = useTheme()
  const { t } = useTranslation();
  
  var engagement = 'NA';

  if (props.engagement != null && props.engagement != undefined) {
    engagement = `${props.engagement * 100}`.substring(0, 4) + '%';
  }

  const tooltipText = t('Engagement tooltip');

  return (
    <Tooltip title={tooltipText}>
      <ChipWithIcons
        data-id="clipboard-list-button"
        label={engagement}
        startIcon={<Icon icon="clipboard-list" color={'primary'} />}
        background={theme.palette.colors.white}
        {...props}
      />
    </Tooltip>
  );
};

export default React.memo(ClipboardListButtonCell);
